import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_pos_vendas'])) {
            can('manage', 'POSVENDAS')
        }
        if (user.temPermissao(['pos_vendas'])) {
            can(['read', 'edit', 'upload'], 'POSVENDAS');
        }
        if (user.temPermissao(['pos_vendas_leitura'])) {
            can(['read'], 'POSVENDAS');
        }
    }

    return build()
}